import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import webHomeBackground from "../assets/home-hero-background.png";
import WebHeader from "../components/WebHeader";
import { applyWebSeo } from "../seo/applyWebSeo";
import { homeSeo } from "../seo/homeSeo";
import "../styles/web.css";

const airports = [
  ["JFK Airport", "/westchester-airport-car-service/"],
  ["LaGuardia Airport (LGA)", "/westchester-airport-car-service/"],
  ["Newark Liberty Airport (EWR)", "/westchester-airport-car-service/"],
  ["Westchester County Airport (HPN)", "/hpn-airport-car-service/"],
  ["Stewart International Airport (SWF)", "/westchester-airport-car-service/"],
];

const benefitHeadingStyle = {
  display: "inline",
  margin: 0,
  font: "inherit",
};

const internalLinkStyle = { color: "inherit", textDecoration: "none" };

const FeatherIcon = ({ children, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {children}
  </svg>
);

const CalendarIcon = (props) => (
  <FeatherIcon {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </FeatherIcon>
);

const CheckCircleIcon = (props) => (
  <FeatherIcon {...props}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </FeatherIcon>
);

const PhoneIcon = (props) => (
  <FeatherIcon {...props}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </FeatherIcon>
);

function WebHome() {
  useEffect(() => applyWebSeo(homeSeo), []);

  return (
    <div className="web-page web-home">
      <link rel="preload" as="image" href={webHomeBackground} fetchPriority="high" />
      <WebHeader />
      <main className="web-page__content web-home__hero" style={{ backgroundImage: `url(${webHomeBackground})` }} aria-labelledby="web-home-title">
        <div className="web-home__copy">
          <h1 id="web-home-title">Private Car Service<span>in Westchester</span></h1>
          <p>Jet Black Limousine provides private car service in Westchester from <Link to="/yorktown-heights-black-car-service/" aria-label="Yorktown Heights black car service" style={internalLinkStyle}>Yorktown Heights</Link>, Bedford, Scarsdale and White Plains, with black car service to NYC and major airports including JFK, LGA, EWR, HPN and SWF. Call (914) 962-8444 or reserve online.</p>
          <div className="web-home__actions">
            <Link className="web-button web-button--primary" to="/booking"><CalendarIcon aria-hidden="true" />BOOK AIRPORT RIDE</Link>
            <a className="web-button web-button--secondary" href="tel:+19149628444"><PhoneIcon aria-hidden="true" />CALL (914) 962-8444</a>
          </div>
          <ul className="web-home__benefits" aria-label="Jet Black service benefits">
            <li><CheckCircleIcon aria-hidden="true" /><span style={benefitHeadingStyle}>Private Chauffeurs</span></li>
            <li><CheckCircleIcon aria-hidden="true" /><span style={benefitHeadingStyle}>24/7 Airport Transportation</span></li>
            <li><CheckCircleIcon aria-hidden="true" /><span style={benefitHeadingStyle}>On-Time Guarantee</span></li>
          </ul>
        </div>
      </main>
      <section className="web-airports" aria-labelledby="airports-title">
        <div className="web-airports__intro">
          <h2 id="airports-title">Airport Transportation and Local Service</h2>
          <p>Book premium airport car service and black car service from Yorktown Heights and Westchester County to JFK, LGA, EWR, HPN, SWF and NYC, or <Link to="/services" aria-label="Compare Westchester transportation services" style={internalLinkStyle}>compare transportation services</Link> before reserving.</p>
        </div>
        <div className="web-airports__list" aria-label="Airport transportation destinations">
          {airports.map(([airport, href]) => (
            <Link className="web-airports__link" to={href} key={airport} aria-label={`Book Westchester airport car service to or from ${airport}`}>{airport}</Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default WebHome;
